import {
  TOGGLE_DARK_MODE,
  TOGGLE_FEED_VIEW_MODE,
  GET_FEED,
} from './actionTypes';

export const toggleDarkMode = isDarkMode => ({
  type: TOGGLE_DARK_MODE,
  payload: { isDarkMode },
});

export const toggleFeedView = feedView => ({
  type: TOGGLE_FEED_VIEW_MODE,
  payload: { feedView },
});

export const getFeed = feedItems => ({
  type: GET_FEED,
  payload: { feedItems },
});
